import { AdministrationServicePath } from "utils/constants";
import { buildFilterQueryString, buildQueryString } from "utils/helpers";

export const administrationRequests = {
  // Specialities — sub-resources
  getSpecialityGenderDistributionByIds: (ids = []) =>
    `${AdministrationServicePath}specialities/gender-distribution${buildQueryString({ ids })}`,
  getSpecialityStudyWeeks: specialityId => `${AdministrationServicePath}specialities/${specialityId}/study-weeks`,
  updateSpecialityStudyWeeks: specialityId => `${AdministrationServicePath}specialities/${specialityId}/study-weeks`,
  getSpecialityStreamsSpecification: specialityId =>
    `${AdministrationServicePath}specialities/${specialityId}/specifications/streams`,
  updateSpecialityStreamsSpecification: specialityId =>
    `${AdministrationServicePath}specialities/${specialityId}/specifications/streams`,
  getSpecialityGroupSpecification: specialityId =>
    `${AdministrationServicePath}specialities/${specialityId}/specifications/groups`,
  updateSpecialityGroupSpecification: specialityId =>
    `${AdministrationServicePath}specialities/${specialityId}/specifications/groups`,
  getSpecialityHasSpecialGroup: specialityId =>
    `${AdministrationServicePath}specialities/${specialityId}/has-special-group`,
  getAnnualFeePlansHistory: specialityId =>
    `${AdministrationServicePath}specialities/annual-fees/${specialityId}/history`,

  // Structural units — group specification
  getStructuralUnitGroupSpecification: structuralUnitId =>
    `${AdministrationServicePath}structural-units/${structuralUnitId}/group-specifications`,
  updateStructuralUnitGroupSpecification: structuralUnitId =>
    `${AdministrationServicePath}structural-units/${structuralUnitId}/group-specifications`,

  // Structural units — study department info (one record for bulgarians, one for foreigners)
  getStudyDepartmentInfo: (structuralUnitId, isForeigner) =>
    `${AdministrationServicePath}structural-units/study-department-info/${structuralUnitId}${buildQueryString({ isForeigner })}`,
  updateStudyDepartmentInfo: structuralUnitId =>
    `${AdministrationServicePath}structural-units/study-department-info/${structuralUnitId}`,

  // Directions
  getDirectionFlags: directionId => `${AdministrationServicePath}directions/${directionId}/flags`,

  // Wards
  deactivateWard: wardId => `${AdministrationServicePath}wards/${wardId}/deactivate`,

  // Holidays
  getHolidays: ({ dateFrom, dateTo } = {}) =>
    `${AdministrationServicePath}holidays${buildQueryString({ DateFrom: dateFrom, DateTo: dateTo })}`,
  updateHolidays: () => `${AdministrationServicePath}holidays`,

  // Leaves — working days count
  getWorkingDaysCount: ({ dateFrom, dateTo } = {}) =>
    `${AdministrationServicePath}selects/working-days-count${buildQueryString({ dateFrom, dateTo })}`,

  // Nomenclatures
  getNomenclatureCsv: objectType => `${AdministrationServicePath}${objectType}/csv`,
  getSettlementsByIdsSelect: (ids = []) =>
    `${AdministrationServicePath}selects/settlements?ids=${(Array.isArray(ids) ? ids : [ids]).join(",")}&PerPage=1`,
  getSettlementById: id => `${AdministrationServicePath}settlements/${id}`,

  getDisciplineById: id => `${AdministrationServicePath}disciplines/${id}`,
  // Selects
  getCountriesSelect: () => `${AdministrationServicePath}selects/countries`,
  getSettlementsSelect: () => `${AdministrationServicePath}selects/settlements`,
  getForeignLanguagesSelect: () => `${AdministrationServicePath}selects/foreign-languages`,
  getDirectionsSelect: () => `${AdministrationServicePath}selects/directions`,
  getProfessionalDirectionsSelect: () => `${AdministrationServicePath}selects/professional-directions`,
  getStructuralUnitsSelect: () => `${AdministrationServicePath}selects/structural-units`,
  getDisciplineTypesSelect: () => `${AdministrationServicePath}selects/discipline-types`,
  getBuildingsSelect: () => `${AdministrationServicePath}selects/buildings`,
  getTechnicalEquipmentTypesSelect: () => `${AdministrationServicePath}selects/technical-equipment-types`,
  getRoomsSelect: () => `${AdministrationServicePath}selects/rooms`,
  getStudyTypesSelect: () => `${AdministrationServicePath}selects/study-types`,
  getStudyTypesBySpecialityId: specialityId => `${AdministrationServicePath}specialities/${specialityId}/study-types`,
  getSpecialityFlags: specialityId => `${AdministrationServicePath}specialities/${specialityId}/flags`,
  getInstructionLanguagesBySpecialityId: specialityId =>
    `${AdministrationServicePath}specialities/${specialityId}/instruction-languages`,

  getReceptionTypesSelect: () => `${AdministrationServicePath}selects/reception-types`,
  getAdmissionReasonsSelect: () => `${AdministrationServicePath}selects/admission-reasons`,
  getPaidEducationAnnualTaxTypesSelect: () => `${AdministrationServicePath}selects/paid-education-annual-tax-types`,
  getExamsSelect: () => `${AdministrationServicePath}selects/exams`,
  getIntermediariesSelect: () => `${AdministrationServicePath}selects/intermediaries`,
  getDegreesSelect: () => `${AdministrationServicePath}selects/degrees`,
  getPreparatoryCoursesSelect: () => `${AdministrationServicePath}selects/preparatory-courses`,
  getSpecialitiesSelect: () => `${AdministrationServicePath}selects/specialities`,
  getSpecialitiesByStructuralUnitIdSelect: structuralUnitId =>
    `${AdministrationServicePath}selects/specialities${buildFilterQueryString({ StructuralUnitId: structuralUnitId })}`,
  getRoomClassTypesSelect: () => `${AdministrationServicePath}selects/room-class-types`,
  getExamTypesSelect: () => `${AdministrationServicePath}selects/exam-types`,
  getExamCategoriesSelect: () => `${AdministrationServicePath}selects/exam-categories`,
  getTaxTypesSelect: () => `${AdministrationServicePath}selects/preference-tax-types`,
  getPreferenceDocumentTypesSelect: () => `${AdministrationServicePath}selects/document-types`,

  // Preferences
  getPreferencesSelect: () => `${AdministrationServicePath}preferences`,
  getPreferenceById: id => `${AdministrationServicePath}preferences/${id}`,
  getPreferencesAdditionalData: (preferenceIds = []) =>
    `${AdministrationServicePath}preferences/additional-data${buildQueryString({ PreferenceIds: preferenceIds })}`,
  getExamSpecialitiesSelect: (specialityIds = []) =>
    `${AdministrationServicePath}selects/exam-specialities${buildQueryString({ specialitiesIds: specialityIds })}`,
  getRoomTypesSelect: () => `${AdministrationServicePath}selects/rooms-types`,
  getDepartmentsSelect: () => `${AdministrationServicePath}selects/departments`,
  getDisciplinesSelect: () => `${AdministrationServicePath}selects/disciplines`,
  getTopicsSelect: () => `${AdministrationServicePath}selects/topics`,
  getRoomsCapacitiesSelect: (roomIds = [], classTypes, showExamCapacity) =>
    `${AdministrationServicePath}selects/rooms-capacities${buildQueryString({
      ids: roomIds,
      classTypes,
      showExamCapacity,
    })}`,
  getLaureatesSelect: () => `${AdministrationServicePath}laureates`,
  getCitizenshipSelect: () => `${AdministrationServicePath}selects/citizenship`,
  getGradingScalesSelect: () => `${AdministrationServicePath}grading-scales/select`,
  getInstructionLanguagesSelect: () => `${AdministrationServicePath}selects/instruction-languages`,
  getInstructionLanguagesBySpecialityIdSelect: specialityId =>
    `${AdministrationServicePath}selects/instruction-languages${buildFilterQueryString({ SpecialityId: specialityId })}`,
  getSpecificRequirementsSelect: () => `${AdministrationServicePath}selects/specific-requirements`,
  getMunicipalitiesSelect: () => `${AdministrationServicePath}selects/municipalities`,
  getDistrictsSelect: () => `${AdministrationServicePath}selects/districts`,
  getPracticesSelect: () => `${AdministrationServicePath}selects/practices`,
  getStateExamsSelect: () => `${AdministrationServicePath}selects/state-exams`,
  getInternshipsSelect: () => `${AdministrationServicePath}selects/internships`,
  getWardsSelect: () => `${AdministrationServicePath}selects/wards`,
  getAdmissionAfterEducationLevelsSelect: () => `${AdministrationServicePath}selects/admission-after-education-levels`,
  getClinicsSelect: () => `${AdministrationServicePath}selects/clinics`,
  getHospitalitiesSelect: () => `${AdministrationServicePath}selects/hospitalities`,
  getUniversitiesSelect: () => `${AdministrationServicePath}selects/universities`,
};
